<template>
  <div class="ml-5 mr-5">
    <div class="text-center">
      <loading :active.sync="isLoaderVisible" :can-cancel="false" loader="dots" color="#007bff" :height="45" :width="75"
        :is-full-page="true"></loading>
    </div>

    <div class="text-left">
      <v-container fluid>
        <v-row class="no-gutters">
          <v-col cols="12" class="mb-5" md="4">
            <v-autocomplete v-model="searchInput" :items="companySuggestions" label="Search By Company"
              variant="outlined" clearable hide-no-data hide-details no-filter :loading="isSearchingCompany"
              :menu-props="{ maxHeight: 200 }" @update:search-input="onSearchInput" @change="onSelectSuggestion" />

          </v-col>

          <v-col class="d-flex align-center justify-end" style="flex-wrap: wrap;">
            <v-btn color="primary" class="mr-4" small v-show="checkIfOperationExistForModule('add')"
              @click="showMemberForm = true">
              Add SSO
            </v-btn>
            <v-btn color="primary" class="mr-0" small v-show="checkIfOperationExistForModule('delete')"
              :disabled="selectedItems.length === 0" @click="handleDeleteRecords">
              Delete
            </v-btn>
          </v-col>
        </v-row>
        <v-row>
          <v-col>
            <div class="tableWrapper">
              <v-data-table :loading="isLoading" :headers="headers" :items="items" :page.sync="page"
                :options.sync="options" :server-items-length="totRecords" @page-count="pageCount = $event"
                v-model="selectedItems" hide-default-footer show-select item-key="id" class="elevation-1">
                <template v-slot:item.actions="{ item }">
                  <v-row class="no-gutters">
                    <v-col class="text-left">
                      <v-icon @click="handleEditRecord(item)" title="Edit"
                        v-show="checkIfOperationExistForModule('edit')">mdi-pencil</v-icon>
                    </v-col>

                  </v-row>
                </template>
                     <template v-slot:item.enableSSO="{ item }">
  <v-switch
    v-model="item.enableSSO"
    inset
    dense
    @change="handleToggleSSO(item)"
  ></v-switch>
</template>

              </v-data-table>

              <div class="text-center pt-4 pb-4">
                <Pagination :isloading="isLoading" :startRecord="startRecord" :currentPage="currentPage"
                  :lastPage="lastPage" :lastRecord="lastRecord" :totRecords="totRecords"
                  :isCurrentPageClass="isCurrentPageClass" :perpage="perpage" :getLastPageClass="getLastPageClass"
                  :totPage="totPage" :getPages="getPages" @handlePerPage="handlePerPage" @paginate="paginate"
                  @last="last" @getDataByPage="getDataByPage" :showPerPage="true" />
              </div>
            </div>
          </v-col>
        </v-row>
      </v-container>
    </div>

    <member-import-dialog :isOpen="showMemberImportDialog" @import="handleMembersImport"
      @close="showMemberImportDialog = false" />
    <v-dialog v-model="showMemberForm" max-width="600">
      <v-card>
        <v-card-title class="text-h6 primary">
          <h2 class="mb-2" style="color: white !important;">
            {{ isEditMode ? "Edit SSO Configuration" : "Add SSO Configuration" }}
          </h2>
        </v-card-title>


        <v-card-text>
          <v-form ref="ssoForm" v-model="isSSOFormValid">

            <v-text-field label="SSO Company Name" v-model="ssoForm.company_name"
              :rules="[v => !!v || 'This field is required']" required />

            <v-text-field label="AWS Cognito User Pool ID" v-model="ssoForm.aws_cognito_user_pool_id"
              :rules="[v => !!v || 'This field is required']" required />

            <v-text-field label="Company Domain" v-model="ssoForm.company_domain"
              :rules="[v => !!v || 'This field is required']" required />

            <v-text-field label="AWS Cognito User Pool Client ID" v-model="ssoForm.aws_cognito_user_pool_client_id"
              :rules="[v => !!v || 'This field is required']" required />

            <v-text-field label="AWS Cognito User Pool Client Secret"
              v-model="ssoForm.aws_cognito_user_pool_client_secret" type="password"
              :append-icon="showSecret ? 'mdi-eye-off' : 'mdi-eye'" @click:append="showSecret = !showSecret"
              :type="showSecret ? 'text' : 'password'" :rules="[v => !!v || 'This field is required']" required />

            <v-text-field label="AWS Cognito Domain" v-model="ssoForm.aws_cognito_domain"
              :rules="[v => !!v || 'This field is required']" required />

          </v-form>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>

          <v-btn text @click="resetSSOForm">Cancel</v-btn>

          <v-btn color="primary" @click="isEditMode ? updateSSO() : saveSSO()" :loading="isMemberFormLoading">
            {{ isEditMode ? "Update" : "Save" }}
          </v-btn>


        </v-card-actions>
      </v-card>
    </v-dialog>

  </div>
</template>
<script>

import Loading from "vue-loading-overlay";
import Pagination from "./component/Pagination.vue";
import SearchField from './component/SearchField.vue';
import MemberImportDialog from "./components/manage-members/MemberImportDialog.vue";

import "vue-loading-overlay/dist/vue-loading.css";

export default {
  components: { Loading, Pagination, SearchField, MemberImportDialog, },
  data() {
    return {
      items: [],
      selectedItems: [],
      isLoaderVisible: false,
      ssoList: [],
      activeSearch: "",
      companySuggestions: [],
      isSearchingCompany: false,
      emailSearchQuery: "",
      searchDebounce: null,
      searchInput: "",

      totalRecords: 0,
      page: 1,
      limit: 10,
      originalSSOData: {},
      options: {},
      isLoading: false,

      pageCount: 0,
      perpage: 10,
      totRecords: 0,
      isEditMode: false,
      sortDesc: true,
      sortBy: "emailAddress",
      showSecret: false,
      isSSOFormValid: false,
      ssoForm: {
        company_name: "",
        aws_cognito_user_pool_id: "",
        aws_cognito_user_pool_client_id: "",
        aws_cognito_user_pool_client_secret: "",
        aws_cognito_domain: "",
        company_domain: ""
      },


      isMemberFormLoading: false,
      showMemberForm: false,
      showMemberImportDialog: false,
      isToggleActivate: false,
      isDeletingRecords: false,
      isImportingMembers: false,
      isExportingMembers: false,
      editUserId: null,

      headers: [
        {
          text: "Company Name",
          value: "company_name",
          sortable: true,
          width: "160",
          class: "v-data-table-header",
        },
        {
          text: "User Pool ID",
          value: "user_pool_id",
          sortable: true,
          width: "160",
          class: "v-data-table-header",
        },
        {
          text: "Client Pool ID",
          value: "client_pool_id",
          sortable: true,
          width: "160",
          class: "v-data-table-header",
        },
        {
          text: "Client Secret",
          value: "client_secret",
          sortable: true,
          width: "200",
          class: "v-data-table-header",
        },
        {
          text: "Cognito Domain",
          value: "cognito_domain",
          sortable: true,
          width: "160",
          class: "v-data-table-header",
        },
        {
          text: "Company Domain",
          value: "company_domain",
          sortable: true,
          width: "160",
          class: "v-data-table-header",
        },
        {
          text: "Actions",
          value: "actions",
          sortable: false,
          width: "100",
          class: "v-data-table-header",
        },
        {
          text: "SSO",
          value: "enableSSO",
          sortable: false,
          width: "50",
          class: "v-data-table-header",
        },
      ]

    };
  },
  watch: {
    searchInput(newVal) {
      if (!newVal || newVal.length < 4) {
        this.companySuggestions = [];
        return;
      }

      this.handleCompanySearch(newVal);
    }
  },

  computed: {
    isLoaderVisible() {
      return this.isLoading
        || this.isToggleActivate
        || this.isDeletingRecords
        || this.isImportingMembers
        || this.isExportingMembers
        || this.isMemberFormLoading
    },
    usersPayload() {
      return {
        page_number: this.page,
        page_size: this.perpage,
        emailAddress: this.emailSearchQuery,
      }
    },
    startRecord: function () {
      return parseInt(this.lastRecord) - parseInt(this.perpage) + parseInt(1);
    },
    lastRecord: function () {
      return this.perpage * this.currentPage;
    },
    isCurrentPageClass: function () {
      return this.currentPage === 1 ? "" : "notactivespan";
    },
    getLastPageClass: function () {
      return parseInt(this.lastPage) === parseInt(this.currentPage)
        ? ""
        : "notactivespan";
    },
    totPage: function () {
      return Math.ceil(parseInt(this.totRecords) / parseInt(this.perpage));
    },
    getPages: function () {
      return this.$utils.getPages(
        this.lastPage,
        this.currentPage,
        this.totPage
      );
    },
    currentPage: function () {
      return this.page;
    },
    lastPage: function () {
      return Math.ceil(parseInt(this.totRecords) / parseInt(this.perpage));
    },
    endIndex: function () {
      return this.perpage * this.page;
    },
    startIndex: function () {
      if (this.page == 1) {
        return this.perpage * 0;
      } else {
        return this.endIndex - this.perpage;
      }
    },
  },

  methods: {
    mapSSOItem(item) {
  return {
    id: item.id,
    company_name: item.company_name,
    user_pool_id: item.user_pool_id,
    client_pool_id: item.client_pool_id,
    client_secret: item.client_secret,
    cognito_domain: item.cognito_domain,
    company_domain: item.company_domain,
    enableSSO: Boolean(item.is_sso),
  };
},

    getDataByPage(value) {
      this.page = value;
      this.fetchSSOList();
    },
    onSearchInput(val) {
      if (!val || val.length < 3) {
        this.companySuggestions = [];
        return;
      }

      clearTimeout(this.searchDebounce);
      this.searchDebounce = setTimeout(() => {
        this.fetchCompanySuggestions(val);
      }, 400);
    },

    onSelectSuggestion(val) {

      if (!val) {
        this.searchInput = "";
        this.activeSearch = "";
        this.fetchSSOList();
        return;
      }
      this.searchInput = val;
      this.activeSearch = val;
      this.fetchExactMatch(val);
    },


async fetchSSOList() {
  this.selectedItems = [];
  this.isLoading = true;

  try {
    const url = this.$url("SSO_LIST");

    const response = await this.$fetch({
      requiresAuth: true,
      operation: "fetch",
      vueScope: this,
    }).get(url, {
      params: {
        page: this.page,
        limit: this.perpage,
        search_company: this.activeSearch || ""
      }
    });

    const res = response.data.data;

  this.items = res.sso_data.map(this.mapSSOItem);


    this.totRecords = res.total_records;
    this.pageCount = Math.ceil(res.total_records / this.perpage);

  } catch (error) {
    console.error("Error fetching SSO list:", error);
    this.$swal.fire({
      icon: "error",
      title: "Error",
      text: "Unable to load SSO list",
    });
  } finally {
    this.isLoading = false;
  }
},


    async updateSSO() {
      if (!this.$refs.ssoForm.validate()) {
        return;
      }

      this.isMemberFormLoading = true;

      try {
        let url = this.$url("SSO_LIST");
        const updateFields = {};

        if (this.ssoForm.company_name !== this.originalSSOData.company_name) {
          updateFields.company_name = this.ssoForm.company_name;
        }
        if (this.ssoForm.aws_cognito_user_pool_id !== this.originalSSOData.aws_cognito_user_pool_id) {
          updateFields.user_pool_id = this.ssoForm.aws_cognito_user_pool_id;
        }
        if (this.ssoForm.aws_cognito_user_pool_client_id !== this.originalSSOData.aws_cognito_user_pool_client_id) {
          updateFields.client_pool_id = this.ssoForm.aws_cognito_user_pool_client_id;
        }
        if (this.ssoForm.aws_cognito_user_pool_client_secret !== this.originalSSOData.aws_cognito_user_pool_client_secret) {
          updateFields.client_secret = this.ssoForm.aws_cognito_user_pool_client_secret;
        }
        if (this.ssoForm.aws_cognito_domain !== this.originalSSOData.aws_cognito_domain) {
          updateFields.cognito_domain = this.ssoForm.aws_cognito_domain;
        }
        if (this.ssoForm.company_domain !== this.originalSSOData.company_domain) {
          updateFields.company_domain = this.ssoForm.company_domain;
        }

        const payload = {
          id: this.editUserId,
          update_fields: updateFields
        };

        await this.$fetch({
          requiresAuth: true,
          operation: "edit",
          vueScope: this,
        }).put(url, payload);

        this.$swal.fire({
          icon: "success",
          title: "Updated",
          text: "SSO configuration updated successfully",
        });

        this.resetSSOForm();
        this.fetchSSOList();

      } catch (e) {
        console.error(e);
        this.$swal.fire({
          icon: "error",
          title: "Error",
          text: "Something went wrong!",
        });
      } finally {
        this.isMemberFormLoading = false;
      }
    },


    handlePerPage(value) {
      if (this.perpage === value) return;
      this.selectedItems = []; 
      this.perpage = value;
      this.page = 1;
      this.fetchSSOList();
    },

    paginate(n) {
      this.selectedItems = []; 
      if (n === 0) this.page = 1;
      else this.page = Math.min(Math.max(1, this.page + n), this.pageCount);

      this.fetchSSOList();
    },

    last() {
      this.page = this.lastPage;
      this.fetchSSOList();
    },


    handleEmailSearch(query) {
      this.emailSearchQuery = query
      this.page = 1;
    },
    resetSSOForm() {
      this.showMemberForm = false;

      this.isEditMode = false;

      this.$refs.ssoForm.reset();

      this.ssoForm = {
        company_name: "",
        aws_cognito_user_pool_id: "",
        aws_cognito_user_pool_client_id: "",
        aws_cognito_user_pool_client_secret: "",
        aws_cognito_domain: "",
      };
    },


    async saveSSO() {
      if (!this.$refs.ssoForm.validate()) {
        return;
      }

      this.isMemberFormLoading = true;

      try {
        let url = this.$url("SSO_ADD");

        const payload = {
          company_name: this.ssoForm.company_name,
          user_pool_id: this.ssoForm.aws_cognito_user_pool_id,
          client_pool_id: this.ssoForm.aws_cognito_user_pool_client_id,
          client_secret: this.ssoForm.aws_cognito_user_pool_client_secret,
          cognito_domain: this.ssoForm.aws_cognito_domain,
          company_domain: this.ssoForm.company_domain
        };

        await this.$fetch({
          requiresAuth: true,
          operation: "add",
          vueScope: this,
        }).post(url, payload);

        this.$swal.fire({
          icon: "success",
          title: "Success",
          text: "SSO configuration added successfully",
        });

        this.resetSSOForm();
        this.fetchSSOList();

      } catch (error) {
  console.error(error);

  const apiMessage = error?.response?.data?.message;
  const statusCode = error?.response?.status;

  let errorText = "Something went wrong!";
  if (
    statusCode === 400 &&
    apiMessage &&
    apiMessage.toLowerCase().includes("duplicate")
  ) {
    errorText = "SSO configuration for this company already exists.";
  } else if (apiMessage) {
    errorText = apiMessage;
  }

  this.$swal.fire({
    icon: "error",
    title: "Error",
    text: errorText,
  });
}

      finally {
        this.isMemberFormLoading = false;
      }
    },
async handleToggleSSO(item) {
  this.isToggleActivate = true;

  const previousValue = !item.enableSSO; 

  const payload = {
    company_domain: item.company_domain,
    enableSSO: item.enableSSO,  
  };

  try {
    const updateUrl = this.$url("DOMAIN_UPDATE_SSO");

    await this.$fetch({
      requiresAuth: true,
      operation: "edit",
      vueScope: this,
    }).put(updateUrl, payload);

    this.$swal.fire({
      icon: "success",
      text: item.enableSSO ? "SSO Enabled" : "SSO Disabled",
    });

  } catch (error) {

    item.enableSSO = previousValue;

    this.$swal.fire({
      icon: "error",
      text: "Unable to update SSO status",
    });
  } finally {
    this.isToggleActivate = false;
  }
},


    async fetchCompanySuggestions(searchText) {
      this.isSearchingCompany = true;

      try {
        const url = this.$url("SSO_SEARCH");

        const response = await this.$fetch({
          requiresAuth: true,
          operation: "view",
          vueScope: this,
        }).post(url, {
          search_company: searchText,
        });

        const data = response.data?.data || [];

        this.companySuggestions = data.map(item => item.company_name);

      } catch (e) {
        console.error("Error:", e);
        this.companySuggestions = [];
      } finally {
        this.isSearchingCompany = false;
      }
    },
    
async fetchExactMatch(companyName) {
  this.isLoading = true;

  try {
    const url = this.$url("SSO_SEARCH");

    const response = await this.$fetch({
      requiresAuth: true,
      operation: "fetch",
      vueScope: this,
    }).post(url, { exact_match: companyName });

    const data = response.data?.data || {};

    this.items = [this.mapSSOItem(data)];

    this.totRecords = 1;
    this.pageCount = 1;
    this.page = 1;

  } catch (error) {
    console.error("Exact match error:", error);
    this.$swal.fire({
      icon: "error",
      title: "Error",
      text: "Unable to fetch company SSO details",
    });
  } finally {
    this.isLoading = false;
  }
},



    resetEmailSearch() {
      this.emailSearchQuery = ''
      this.page = 1;
    },
    async handleEditRecord(item) {
      this.isEditMode = true;
      this.showMemberForm = true;

      this.ssoForm = {
        company_name: item.company_name,
        aws_cognito_user_pool_id: item.user_pool_id,
        aws_cognito_user_pool_client_id: item.client_pool_id,
        aws_cognito_user_pool_client_secret: item.client_secret,
        aws_cognito_domain: item.cognito_domain,
        company_domain: item.company_domain
      };

      this.editUserId = item.id;

      this.originalSSOData = { ...this.ssoForm };
    },

    async handleDeleteRecords() {
      if (!this.selectedItems.length) {
        this.$swal.fire({
          icon: "warning",
          title: "No items selected",
          text: "Please select at least one record to delete.",
        });
        return;
      }

      this.$swal.fire({
        title: "Are you sure?",
        text: "This will delete selected SSO record(s).",
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Yes, delete",
        cancelButtonText: "Cancel",
      }).then(async (result) => {


        if (!result.isConfirmed) return;

        this.isDeletingRecords = true;

        try {
          const url = this.$url("SSO_LIST");

          const payload = {
            ids: this.selectedItems.map(item => item.id)
          };

          await this.$fetch({
            requiresAuth: true,
            operation: "delete",
            vueScope: this,
          }).delete(url, { data: payload });

          this.$swal.fire({
            icon: "success",
            title: "Deleted",
            text: "Selected SSO record(s) deleted successfully.",
          });

          this.selectedItems = [];
          this.fetchSSOList();

        } catch (error) {
          console.error(error);
          this.$swal.fire({
            icon: "error",
            title: "Error",
            text: "Unable to delete SSO record(s).",
          });
        } finally {
          this.isDeletingRecords = false;
        }
      });
    },



    checkIfOperationExistForModule(type) {
      return this.$utils.checkIfOperationExistForModule(this, type);
    },


  },
  mounted() {
    this.fetchSSOList();
  }

};
</script>
